import {
  Home,
  Truck,
  Shield,
  Users,
  Navigation,
  Briefcase,
  Clipboard,
  AlertTriangle,
  Map,
  Layers,
  FileText,
  Smartphone,
  Tag,
} from "react-feather";

export const MENUITEMS = [
  {
    title: "dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    path: "/dashboard",
    active: false,
  },
  {
    title: "map",
    icon: Map,
    type: "link",
    path: "/map",
    active: false,
  },
  {
    title: "ambulances",
    icon: Truck,
    type: "link",
    path: "/ambulance-management",
    active: false,
  },
  {
    title: "areas",
    icon: Layers,
    type: "link",
    path: "/area-management",
    active: false,
  },
  {
    title: "services",
    icon: Briefcase,
    type: "link",
    path: "/service-management",
    active: false,
  },
  {
    title: "requests",
    icon: Clipboard,
    type: "sub",
    path: "/user-request-management/urgency",
    active: false,
    children: [
      {
        path: "/user-request-management/urgency",
        title: "urgencies",
        type: "link",
      },
      {
        path: "/user-request-management/reservation",
        title: "reservations",
        type: "link",
      },
    ],
  },
  {
    title: "routes",
    icon: Navigation,
    type: "link",
    path: "/route-logs",
    active: false,
  },
  {
    title: "incidents",
    icon: AlertTriangle,
    type: "link",
    path: "/incident-logs",
    active: false,
  },
  {
    title: "reports",
    icon: FileText,
    type: "sub",
    path: "/generate-report/ambulance",
    active: false,
    children: [
      {
        path: "/generate-report/ambulance",
        title: "ambulances",
        type: "link",
      },
      {
        path: "/generate-report/user-request",
        title: "requests",
        type: "link",
      },
    ],
  },
  {
    title: "users",
    icon: Users,
    type: "sub",
    active: false,
    open: true,
    path: "/users-management/web",
    children: [
      { path: "/users-management/web", title: "users_for_web", type: "link" },
      {
        path: "/users-management/mobile-app",
        title: "users_for_mobile_app",
        type: "link",
      },
    ],
  },
  {
    title: "roles",
    icon: Shield,
    type: "link",
    active: false,
    path: "/role-management",
  },
  {
    title: "app_versioning",
    icon: Smartphone,
    type: "link",
    active: false,
    path: "/app-versioning-management",
  },
  {
    title: "advertising",
    icon: Tag,
    type: "link",
    active: false,
    path: "/advertising-management",
  },
];
